import { render, staticRenderFns } from "./StaffDashboardTable.vue?vue&type=template&id=6de40ecc&scoped=true&"
import script from "./StaffDashboardTable.vue?vue&type=script&lang=js&"
export * from "./StaffDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffDashboardTable.vue?vue&type=style&index=0&id=6de40ecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de40ecc",
  null
  
)

export default component.exports